module.exports = __webpack_public_path__ + "static/media/box-delivery.49a263f8.webp";